module.exports = __webpack_public_path__ + "img/logout.c5dab17d.svg";